export default __webpack_public_path__ + "assets/ogg/5377ef35568956b46c2ec521d77940b0.ogg";